import React, { Component } from "react";
import {
  DatePicker,
  Select,
  Radio,
  Space,
  Checkbox,
  message,
  Spin,
  Input,
} from "antd";
import Bridge from "../../../../utils/Bridge";
import moment from "moment";
import { RESEARCH_TYPE } from "../../../../utils/consts";
import englishJson from "../../../../utils/language/leStudy/english.json";
import spanishJson from "../../../../utils/language/leStudy/spanish.json";
import { LE_STUDY_DEMOGRAPHICS_CONTENT } from "../../../../utils/consts";

export default class MedicalHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,

      neurological_disease: "",
      neurological_disease_specification: "",
      stroke: "",
      stroke_specification: "",
      traumatic_brain_injury: "",
      traumatic_brain_injury_specification: "",
      respiratory_disease: "",
      respiratory_disease_specification: "",
      bipolar_disorder: "",
      bipolar_disorder_specification: "",
      brain_aneurysm: "",
      brain_aneurysm_specification: "",
      cancer: "",
      cancer_specification: "",
      depression: "",
      depression_specification: "",
      diabetes: "",
      diabetes_specification: "",
      epilepsy: "",
      epilepsy_specification: "",
      muscle_disease: "",
      muscle_disease_specification: "",
      schizophrenia: "",
      schizophrenia_specification: "",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.le_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Neurological disease") {
                this.setState({
                  neurological_disease: item.value,
                });
              }
              if (item.field == "Neurological disease Specification") {
                this.setState({
                  neurological_disease_specification: item.value,
                });
              }
              if (item.field == "Stroke") {
                this.setState({
                  stroke: item.value,
                });
              }
              if (item.field == "Stroke Specification") {
                this.setState({
                  stroke_specification: item.value,
                });
              }
              if (item.field == "Traumatic Brain Injury") {
                this.setState({
                  traumatic_brain_injury: item.value,
                });
              }
              if (item.field == "Traumatic Brain Injury Specification") {
                this.setState({
                  traumatic_brain_injury_specification: item.value,
                });
              }
              if (item.field == "Respiratory disease") {
                this.setState({
                  respiratory_disease: item.value,
                });
              }
              if (item.field == "Respiratory disease Specification") {
                this.setState({
                  respiratory_disease_specification: item.value,
                });
              }
              if (item.field == "Bipolar Disorder") {
                this.setState({
                  bipolar_disorder: item.value,
                });
              }
              if (item.field == "Bipolar Disorder Specification") {
                this.setState({
                  bipolar_disorder_specification: item.value,
                });
              }
              if (item.field == "Brain Aneurysm") {
                this.setState({
                  brain_aneurysm: item.value,
                });
              }
              if (item.field == "Brain Aneurysm Specification") {
                this.setState({
                  brain_aneurysm_specification: item.value,
                });
              }
              if (item.field == "Cancer") {
                this.setState({
                  cancer: item.value,
                });
              }
              if (item.field == "Cancer Specification") {
                this.setState({
                  cancer_specification: item.value,
                });
              }
              if (item.field == "Depression") {
                this.setState({
                  depression: item.value,
                });
              }
              if (item.field == "Depression Specification") {
                this.setState({
                  depression_specification: item.value,
                });
              }
              if (item.field == "Diabetes") {
                this.setState({
                  diabetes: item.value,
                });
              }
              if (item.field == "Diabetes Specification") {
                this.setState({
                  diabetes_specification: item.value,
                });
              }
              if (item.field == "Epilepsy") {
                this.setState({
                  epilepsy: item.value,
                });
              }
              if (item.field == "Epilepsy Specification") {
                this.setState({
                  epilepsy_specification: item.value,
                });
              }
              if (item.field == "Muscle Disease") {
                this.setState({
                  muscle_disease: item.value,
                });
              }
              if (item.field == "Muscle Disease Specification") {
                this.setState({
                  muscle_disease_specification: item.value,
                });
              }
              if (item.field == "Schizophrenia") {
                this.setState({
                  schizophrenia: item.value,
                });
              }
              if (item.field == "Schizophrenia Specification") {
                this.setState({
                  schizophrenia_specification: item.value,
                });
              }
            }
          }
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  save = () => {
    if (!this.state.neurological_disease) {
      message.warning("Please choose 'Neurological Disease' field");
      return;
    }
    if (!this.state.stroke) {
      message.warning("Please choose 'Stroke' field");
      return;
    }
    if (!this.state.traumatic_brain_injury) {
      message.warning("Please choose 'Traumatic Brain Injury' field");
      return;
    }
    if (!this.state.respiratory_disease) {
      message.warning("Please choose 'Respiratory Disease' field");
      return;
    }
    if (!this.state.bipolar_disorder) {
      message.warning("Please choose 'Bipolar Disorder' field");
      return;
    }
    if (!this.state.brain_aneurysm) {
      message.warning("Please choose 'Brain Aneurysm' field");
      return;
    }
    if (!this.state.cancer) {
      message.warning("Please choose 'Cancer' field");
      return;
    }
    if (!this.state.depression) {
      message.warning("Please choose 'Depression' field");
      return;
    }
    if (!this.state.diabetes) {
      message.warning("Please choose 'Diabetes' field");
      return;
    }
    if (!this.state.epilepsy) {
      message.warning("Please choose 'Epilepsy' field");
      return;
    }
    if (!this.state.muscle_disease) {
      message.warning("Please choose 'Muscle Disease' field");
      return;
    }
    if (!this.state.schizophrenia) {
      message.warning("Please choose 'Schizophrenia' field");
      return;
    }
    let questions = [
      {
        parent_field: "Neurological disease",
        field: "Neurological disease",
        value: this.state.neurological_disease,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "neurologicalDisease"
          )?.content.find(
            (item) => item.subtitle == this.state.neurological_disease
          )?.subId || "",
      },
      {
        parent_field: "Neurological disease",
        field: "Neurological disease Specification",
        value: this.state.neurological_disease_specification || "",
      },
      {
        parent_field: "Stroke",
        field: "Stroke",
        value: this.state.stroke,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "stroke"
          )?.content.find((item) => item.subtitle == this.state.stroke)
            ?.subId || "",
      },
      {
        parent_field: "Stroke",
        field: "Stroke Specification",
        value: this.state.stroke_specification || "",
      },
      {
        parent_field: "Traumatic Brain Injury",
        field: "Traumatic Brain Injury",
        value: this.state.traumatic_brain_injury,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "traumaticBrainInjury"
          )?.content.find(
            (item) => item.subtitle == this.state.traumatic_brain_injury
          )?.subId || "",
      },
      {
        parent_field: "Traumatic Brain Injury",
        field: "Traumatic Brain Injury Specification",
        value: this.state.traumatic_brain_injury_specification || "",
      },
      {
        parent_field: "Respiratory disease",
        field: "Respiratory disease",
        value: this.state.respiratory_disease,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "respiratoryDisease"
          )?.content.find(
            (item) => item.subtitle == this.state.respiratory_disease
          )?.subId || "",
      },
      {
        parent_field: "Respiratory disease",
        field: "Respiratory disease Specification",
        value: this.state.respiratory_disease_specification || "",
      },
      {
        parent_field: "Bipolar Disorder",
        field: "Bipolar Disorder",
        value: this.state.bipolar_disorder,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "bipolarDisorder"
          )?.content.find(
            (item) => item.subtitle == this.state.bipolar_disorder
          )?.subId || "",
      },
      {
        parent_field: "Bipolar Disorder",
        field: "Bipolar Disorder Specification",
        value: this.state.bipolar_disorder_specification || "",
      },
      {
        parent_field: "Brain Aneurysm",
        field: "Brain Aneurysm",
        value: this.state.brain_aneurysm,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "brainAneurysm"
          )?.content.find((item) => item.subtitle == this.state.brain_aneurysm)
            ?.subId || "",
      },
      {
        parent_field: "Brain Aneurysm",
        field: "Brain Aneurysm Specification",
        value: this.state.brain_aneurysm_specification || "",
      },
      {
        parent_field: "Cancer",
        field: "Cancer",
        value: this.state.cancer,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "cancer"
          )?.content.find((item) => item.subtitle == this.state.cancer)
            ?.subId || "",
      },
      {
        parent_field: "Cancer",
        field: "Cancer Specification",
        value: this.state.cancer_specification || "",
      },
      {
        parent_field: "Depression",
        field: "Depression",
        value: this.state.depression,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "depression"
          )?.content.find((item) => item.subtitle == this.state.depression)
            ?.subId || "",
      },
      {
        parent_field: "Depression",
        field: "Depression Specification",
        value: this.state.depression_specification || "",
      },
      {
        parent_field: "Diabetes",
        field: "Diabetes",
        value: this.state.diabetes,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "diabetes"
          )?.content.find((item) => item.subtitle == this.state.diabetes)
            ?.subId || "",
      },
      {
        parent_field: "Diabetes",
        field: "Diabetes Specification",
        value: this.state.diabetes_specification || "",
      },
      {
        parent_field: "Epilepsy",
        field: "Epilepsy",
        value: this.state.epilepsy,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "epilepsy"
          )?.content.find((item) => item.subtitle == this.state.epilepsy)
            ?.subId || "",
      },
      {
        parent_field: "Epilepsy",
        field: "Epilepsy Specification",
        value: this.state.epilepsy_specification || "",
      },
      {
        parent_field: "Muscle Disease",
        field: "Muscle Disease",
        value: this.state.muscle_disease,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "muscleDisease"
          )?.content.find((item) => item.subtitle == this.state.muscle_disease)
            ?.subId || "",
      },
      {
        parent_field: "Muscle Disease",
        field: "Muscle Disease Specification",
        value: this.state.muscle_disease_specification || "",
      },
      {
        parent_field: "Schizophrenia",
        field: "Schizophrenia",
        value: this.state.schizophrenia,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "schizophrenia"
          )?.content.find((item) => item.subtitle == this.state.schizophrenia)
            ?.subId || "",
      },
      {
        parent_field: "Schizophrenia",
        field: "Schizophrenia Specification",
        value: this.state.schizophrenia_specification || "",
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "5",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics.le_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          const formData =
            RESEARCH_TYPE == "LE Study"
              ? this.props.language == "English"
                ? englishJson
                : spanishJson
              : englishJson;
          message.success(
            formData.page.demographicQuestions.messages
              .demographicsDataAddedSuccessfully
          );
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                setTimeout(() => {
                  window.location.assign("/dashboard");
                }, 3000);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  onHandleChangeFollowingHistory = (e) => {
    let value = e.target.value;
    let tempArr = this.state.any_history_of_the_following;
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      this.setState({ any_history_of_the_following: newArray });
    } else {
      tempArr.push(value);
      this.setState({ any_history_of_the_following: tempArr });
    }
  };
  render() {
    const formData =
      this.props.language == "English" ? englishJson : spanishJson;
    return (
      <div>
        <div className="header">
          <h3>
            {
              formData.page.demographicQuestions.fields.medicalHistory
                .innerTitle
            }
          </h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <p className="manadatory-note">
              <strong className="text-danger">
                {formData.page.demographicQuestions.note}:
              </strong>{" "}
              {formData.page.demographicQuestions.allFieldsMandatory}
            </p>
            <div className="form-group">
              <label className="input-heading">
                {
                  formData.page.demographicQuestions.fields.medicalHistory
                    .healthyControl.title
                }{" "}
                &nbsp;
                <i style={{ fontWeight: "400" }}>
                  (
                  {
                    formData.page.demographicQuestions.fields.medicalHistory
                      .selectAllThatApply
                  }
                  )
                </i>{" "}
              </label>
              <div>
                <div className="pl-0 col-lg-7">
                  <div className="form-group">
                    <label className="input-heading">
                      {
                        formData.page.demographicQuestions.fields.medicalHistory
                          .healthyControl.neurologicalDisease
                      }
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          neurological_disease: e.target.value,
                          neurological_disease_specification:
                            e.target.value === "No"
                              ? ""
                              : this.state.neurological_disease_specification,
                        })
                      }
                      value={this.state.neurological_disease}
                    >
                      <Space direction="horizontal">
                        {formData.page.demographicQuestions.fields.medicalHistory.yesNoOptions.map(
                          (item, index) => {
                            return (
                              <Radio value={item.value}>{item.label}</Radio>
                            );
                          }
                        )}
                      </Space>
                    </Radio.Group>
                    {this.state.neurological_disease === "Yes" && (
                      <div className="mt-3">
                        <label className="mb-2">
                          {formData.page.demographicQuestions.fields
                            .medicalHistory.pleaseSpecify || "Please Specify"}
                        </label>
                        <br />
                        <Input
                          value={this.state.neurological_disease_specification}
                          onChange={(e) =>
                            this.setState({
                              neurological_disease_specification:
                                e.target.value,
                            })
                          }
                          className="demographics-field-height mb-0"
                          placeholder={
                            formData.page.demographicQuestions.fields
                              .medicalHistory.pleaseSpecify || "Please specify"
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      {
                        formData.page.demographicQuestions.fields.medicalHistory
                          .healthyControl.stroke
                      }
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          stroke: e.target.value,
                          stroke_specification:
                            e.target.value === "No"
                              ? ""
                              : this.state.stroke_specification,
                        })
                      }
                      value={this.state.stroke}
                    >
                      <Space direction="horizontal">
                        {formData.page.demographicQuestions.fields.medicalHistory.yesNoOptions.map(
                          (item, index) => {
                            return (
                              <Radio value={item.value}>{item.label}</Radio>
                            );
                          }
                        )}
                      </Space>
                    </Radio.Group>
                    {this.state.stroke === "Yes" && (
                      <div className="mt-3">
                        <label className="mb-2">
                          {formData.page.demographicQuestions.fields
                            .medicalHistory.pleaseSpecify || "Please Specify"}
                        </label>
                        <br />
                        <Input
                          value={this.state.stroke_specification}
                          onChange={(e) =>
                            this.setState({
                              stroke_specification: e.target.value,
                            })
                          }
                          className="demographics-field-height mb-0"
                          placeholder={
                            formData.page.demographicQuestions.fields
                              .medicalHistory.pleaseSpecify || "Please specify"
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      {
                        formData.page.demographicQuestions.fields.medicalHistory
                          .healthyControl.traumaticBrainInjury
                      }
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          traumatic_brain_injury: e.target.value,
                          traumatic_brain_injury_specification:
                            e.target.value === "No"
                              ? ""
                              : this.state.traumatic_brain_injury_specification,
                        })
                      }
                      value={this.state.traumatic_brain_injury}
                    >
                      <Space direction="horizontal">
                        {formData.page.demographicQuestions.fields.medicalHistory.yesNoOptions.map(
                          (item, index) => {
                            return (
                              <Radio value={item.value}>{item.label}</Radio>
                            );
                          }
                        )}
                      </Space>
                    </Radio.Group>
                    {this.state.traumatic_brain_injury === "Yes" && (
                      <div className="mt-3">
                        <label className="mb-2">
                          {formData.page.demographicQuestions.fields
                            .medicalHistory.pleaseSpecify || "Please Specify"}
                        </label>
                        <br />
                        <Input
                          value={
                            this.state.traumatic_brain_injury_specification
                          }
                          onChange={(e) =>
                            this.setState({
                              traumatic_brain_injury_specification:
                                e.target.value,
                            })
                          }
                          className="demographics-field-height mb-0"
                          placeholder={
                            formData.page.demographicQuestions.fields
                              .medicalHistory.pleaseSpecify || "Please specify"
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      {
                        formData.page.demographicQuestions.fields.medicalHistory
                          .healthyControl.bipolarDisorder
                      }
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          bipolar_disorder: e.target.value,
                          bipolar_disorder_specification:
                            e.target.value === "No"
                              ? ""
                              : this.state.bipolar_disorder_specification,
                        })
                      }
                      value={this.state.bipolar_disorder}
                    >
                      <Space direction="horizontal">
                        {formData.page.demographicQuestions.fields.medicalHistory.yesNoOptions.map(
                          (item, index) => {
                            return (
                              <Radio value={item.value}>{item.label}</Radio>
                            );
                          }
                        )}
                      </Space>
                    </Radio.Group>
                    {this.state.bipolar_disorder === "Yes" && (
                      <div className="mt-3">
                        <label className="mb-2">
                          {formData.page.demographicQuestions.fields
                            .medicalHistory.pleaseSpecify || "Please Specify"}
                        </label>
                        <br />
                        <Input
                          value={this.state.bipolar_disorder_specification}
                          onChange={(e) =>
                            this.setState({
                              bipolar_disorder_specification: e.target.value,
                            })
                          }
                          className="demographics-field-height mb-0"
                          placeholder={
                            formData.page.demographicQuestions.fields
                              .medicalHistory.pleaseSpecify || "Please specify"
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      {
                        formData.page.demographicQuestions.fields.medicalHistory
                          .healthyControl.brainAneurysm
                      }
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          brain_aneurysm: e.target.value,
                          brain_aneurysm_specification:
                            e.target.value === "No"
                              ? ""
                              : this.state.brain_aneurysm_specification,
                        })
                      }
                      value={this.state.brain_aneurysm}
                    >
                      <Space direction="horizontal">
                        {formData.page.demographicQuestions.fields.medicalHistory.yesNoOptions.map(
                          (item, index) => {
                            return (
                              <Radio value={item.value}>{item.label}</Radio>
                            );
                          }
                        )}
                      </Space>
                    </Radio.Group>
                    {this.state.brain_aneurysm === "Yes" && (
                      <div className="mt-3">
                        <label className="mb-2">
                          {formData.page.demographicQuestions.fields
                            .medicalHistory.pleaseSpecify || "Please Specify"}
                        </label>
                        <br />
                        <Input
                          value={this.state.brain_aneurysm_specification}
                          onChange={(e) =>
                            this.setState({
                              brain_aneurysm_specification: e.target.value,
                            })
                          }
                          className="demographics-field-height mb-0"
                          placeholder={
                            formData.page.demographicQuestions.fields
                              .medicalHistory.pleaseSpecify || "Please specify"
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      {
                        formData.page.demographicQuestions.fields.medicalHistory
                          .healthyControl.cancer
                      }
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          cancer: e.target.value,
                          cancer_specification:
                            e.target.value === "No"
                              ? ""
                              : this.state.cancer_specification,
                        })
                      }
                      value={this.state.cancer}
                    >
                      <Space direction="horizontal">
                        {formData.page.demographicQuestions.fields.medicalHistory.yesNoOptions.map(
                          (item, index) => {
                            return (
                              <Radio value={item.value}>{item.label}</Radio>
                            );
                          }
                        )}
                      </Space>
                    </Radio.Group>
                    {this.state.cancer === "Yes" && (
                      <div className="mt-3">
                        <label className="mb-2">
                          {formData.page.demographicQuestions.fields
                            .medicalHistory.pleaseSpecify || "Please Specify"}
                        </label>
                        <br />
                        <Input
                          value={this.state.cancer_specification}
                          onChange={(e) =>
                            this.setState({
                              cancer_specification: e.target.value,
                            })
                          }
                          className="demographics-field-height mb-0"
                          placeholder={
                            formData.page.demographicQuestions.fields
                              .medicalHistory.pleaseSpecify || "Please specify"
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      {
                        formData.page.demographicQuestions.fields.medicalHistory
                          .healthyControl.depression
                      }
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          depression: e.target.value,
                          depression_specification:
                            e.target.value === "No"
                              ? ""
                              : this.state.depression_specification,
                        })
                      }
                      value={this.state.depression}
                    >
                      <Space direction="horizontal">
                        {formData.page.demographicQuestions.fields.medicalHistory.yesNoOptions.map(
                          (item, index) => {
                            return (
                              <Radio value={item.value}>{item.label}</Radio>
                            );
                          }
                        )}
                      </Space>
                    </Radio.Group>
                    {this.state.depression === "Yes" && (
                      <div className="mt-3">
                        <label className="mb-2">
                          {formData.page.demographicQuestions.fields
                            .medicalHistory.pleaseSpecify || "Please Specify"}
                        </label>
                        <br />
                        <Input
                          value={this.state.depression_specification}
                          onChange={(e) =>
                            this.setState({
                              depression_specification: e.target.value,
                            })
                          }
                          className="demographics-field-height mb-0"
                          placeholder={
                            formData.page.demographicQuestions.fields
                              .medicalHistory.pleaseSpecify || "Please specify"
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      {
                        formData.page.demographicQuestions.fields.medicalHistory
                          .healthyControl.diabetes
                      }
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          diabetes: e.target.value,
                          diabetes_specification:
                            e.target.value === "No"
                              ? ""
                              : this.state.diabetes_specification,
                        })
                      }
                      value={this.state.diabetes}
                    >
                      <Space direction="horizontal">
                        {formData.page.demographicQuestions.fields.medicalHistory.yesNoOptions.map(
                          (item, index) => {
                            return (
                              <Radio value={item.value}>{item.label}</Radio>
                            );
                          }
                        )}
                      </Space>
                    </Radio.Group>
                    {this.state.diabetes === "Yes" && (
                      <div className="mt-3">
                        <label className="mb-2">
                          {formData.page.demographicQuestions.fields
                            .medicalHistory.pleaseSpecify || "Please Specify"}
                        </label>
                        <br />
                        <Input
                          value={this.state.diabetes_specification}
                          onChange={(e) =>
                            this.setState({
                              diabetes_specification: e.target.value,
                            })
                          }
                          className="demographics-field-height mb-0"
                          placeholder={
                            formData.page.demographicQuestions.fields
                              .medicalHistory.pleaseSpecify || "Please specify"
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      {
                        formData.page.demographicQuestions.fields.medicalHistory
                          .healthyControl.epilepsy
                      }
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          epilepsy: e.target.value,
                          epilepsy_specification:
                            e.target.value === "No"
                              ? ""
                              : this.state.epilepsy_specification,
                        })
                      }
                      value={this.state.epilepsy}
                    >
                      <Space direction="horizontal">
                        {formData.page.demographicQuestions.fields.medicalHistory.yesNoOptions.map(
                          (item, index) => {
                            return (
                              <Radio value={item.value}>{item.label}</Radio>
                            );
                          }
                        )}
                      </Space>
                    </Radio.Group>
                    {this.state.epilepsy === "Yes" && (
                      <div className="mt-3">
                        <label className="mb-2">
                          {formData.page.demographicQuestions.fields
                            .medicalHistory.pleaseSpecify || "Please Specify"}
                        </label>
                        <br />
                        <Input
                          value={this.state.epilepsy_specification}
                          onChange={(e) =>
                            this.setState({
                              epilepsy_specification: e.target.value,
                            })
                          }
                          className="demographics-field-height mb-0"
                          placeholder={
                            formData.page.demographicQuestions.fields
                              .medicalHistory.pleaseSpecify || "Please specify"
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      {" "}
                      {
                        formData.page.demographicQuestions.fields.medicalHistory
                          .healthyControl.muscleDisease
                      }
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          muscle_disease: e.target.value,
                          muscle_disease_specification:
                            e.target.value === "No"
                              ? ""
                              : this.state.muscle_disease_specification,
                        })
                      }
                      value={this.state.muscle_disease}
                    >
                      <Space direction="horizontal">
                        {formData.page.demographicQuestions.fields.medicalHistory.yesNoOptions.map(
                          (item, index) => {
                            return (
                              <Radio value={item.value}>{item.label}</Radio>
                            );
                          }
                        )}
                      </Space>
                    </Radio.Group>
                    {this.state.muscle_disease === "Yes" && (
                      <div className="mt-3">
                        <label className="mb-2">
                          {formData.page.demographicQuestions.fields
                            .medicalHistory.pleaseSpecify || "Please Specify"}
                        </label>
                        <br />
                        <Input
                          value={this.state.muscle_disease_specification}
                          onChange={(e) =>
                            this.setState({
                              muscle_disease_specification: e.target.value,
                            })
                          }
                          className="demographics-field-height mb-0"
                          placeholder={
                            formData.page.demographicQuestions.fields
                              .medicalHistory.pleaseSpecify || "Please specify"
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      {
                        formData.page.demographicQuestions.fields.medicalHistory
                          .healthyControl.schizophrenia
                      }
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          schizophrenia: e.target.value,
                          schizophrenia_specification:
                            e.target.value === "No"
                              ? ""
                              : this.state.schizophrenia_specification,
                        })
                      }
                      value={this.state.schizophrenia}
                    >
                      <Space direction="horizontal">
                        {formData.page.demographicQuestions.fields.medicalHistory.yesNoOptions.map(
                          (item, index) => {
                            return (
                              <Radio value={item.value}>{item.label}</Radio>
                            );
                          }
                        )}
                      </Space>
                    </Radio.Group>
                    {this.state.schizophrenia === "Yes" && (
                      <div className="mt-3">
                        <label className="mb-2">
                          {formData.page.demographicQuestions.fields
                            .medicalHistory.pleaseSpecify || "Please Specify"}
                        </label>
                        <br />
                        <Input
                          value={this.state.schizophrenia_specification}
                          onChange={(e) =>
                            this.setState({
                              schizophrenia_specification: e.target.value,
                            })
                          }
                          className="demographics-field-height mb-0"
                          placeholder={
                            formData.page.demographicQuestions.fields
                              .medicalHistory.pleaseSpecify || "Please specify"
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      {
                        formData.page.demographicQuestions.fields.medicalHistory
                          .healthyControl.respiratoryDisease
                      }
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          respiratory_disease: e.target.value,
                          respiratory_disease_specification:
                            e.target.value === "No"
                              ? ""
                              : this.state.respiratory_disease_specification,
                        })
                      }
                      value={this.state.respiratory_disease}
                    >
                      <Space direction="horizontal">
                        {formData.page.demographicQuestions.fields.medicalHistory.yesNoOptions.map(
                          (item, index) => {
                            return (
                              <Radio value={item.value}>{item.label}</Radio>
                            );
                          }
                        )}
                      </Space>
                    </Radio.Group>
                    {this.state.respiratory_disease === "Yes" && (
                      <div className="mt-3">
                        <label className="mb-2">
                          {formData.page.demographicQuestions.fields
                            .medicalHistory.pleaseSpecify || "Please Specify"}
                        </label>
                        <br />
                        <Input
                          value={this.state.respiratory_disease_specification}
                          onChange={(e) =>
                            this.setState({
                              respiratory_disease_specification: e.target.value,
                            })
                          }
                          className="demographics-field-height mb-0"
                          placeholder={
                            formData.page.demographicQuestions.fields
                              .medicalHistory.pleaseSpecify || "Please specify"
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  {formData.page.demographicQuestions.button.save}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(4)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  {formData.page.demographicQuestions.button.previous}
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  {formData.page.demographicQuestions.button.savenext}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
